import React from 'react';
import { connect } from 'react-redux';
import { routes } from 'constants/config';
import * as actions from 'actions/shared/index/mass_actions.js';
import MassAction from './MassAction';

const MassTaggingView = ({ applyTags, requestSharedtags, resource }) => (
  <MassAction
    requestShared={requestSharedtags}
    applyChanges={applyTags}
    title={t('mass_actions.mass_tagging.title')}
    placeholder={t('mass_actions.mass_tagging.add_tag')}
    noSharedResourceText={t('mass_actions.mass_tagging.no_shared_tag')}
    autocompleteUrl={routes.TAGS}
    queryParam="q"
    resource={resource}
  />
);

MassTaggingView.defaultProps = {
  resource: 'tags',
};

const mapDispatchToProps = {
  requestSharedtags: actions.requestSharedtags,
  applyTags: actions.applyTags,
};

export default connect(null, mapDispatchToProps)(MassTaggingView);
